export function toJsonl<T>(rows: T[]): string {
  return rows.map((r) => JSON.stringify(r)).join('\n') + (rows.length ? '\n' : '');
}

export function fromJsonl<T = unknown>(s: string): T[] {
  const out: T[] = [];
  for (const line of s.split('\n')) {
    const t = line.trim();
    if (!t) continue;
    out.push(JSON.parse(t));
  }
  return out;
}
